import React, { Component } from 'react';
import AppStore from '../../stores/AppStore';
import Snackbar from 'material-ui/Snackbar';

class ErrorSnackbar extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            errors: []
        };
    }
    componentDidMount() {
        this.onErrorMessage = this.onErrorMessage.bind(this);
        this.removeError = this.removeError.bind(this);
        this.errorListener = AppStore.addErrorListener(this.onErrorMessage);
    }

    componentWillUnmount() {
        this.errorListener.remove();
    }

    render() {
        if (this.state.errors.length === 0) { return null; } // guard

        return (
            <Snackbar
                open={true}
                message={this.state.errors[0]}
                action="OK"
                onActionTouchTap={this.removeError}
                onRequestClose={this.removeError}
            />
        );
    }


    onErrorMessage() {
        const errors = AppStore.clearErrors() || [];
        if (errors.length > 0) {
            this.setState({errors: this.state.errors.concat(errors) });
        }
    }

    removeError() {
        let errors = this.state.errors.slice(1);
        while (errors[0] === this.state.errors[0]) {
            errors.shift();
        }
        this.setState({errors});
    }
}

export default ErrorSnackbar;
